import type { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Switch } from '@vnetwork/ui/primitives';
import type { ContractFormValues } from '../contract-form';

/**
 * The switch-gated header shared by the SLA / NDA config sections: a labelled
 * Switch bound to an enable flag, with an icon and title. The section body is
 * revealed by the caller only while the flag is on (legacy reveal behaviour).
 */
export function ConfigToggleHeader({
  name,
  icon,
  title,
  description,
}: {
  name: 'sla_enable' | 'nda_enable';
  icon: ReactNode;
  title: string;
  description: string;
}) {
  const { control } = useFormContext<ContractFormValues>();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <label
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 'var(--vn-space-4)',
            cursor: 'pointer',
          }}
        >
          <span style={{ display: 'flex', gap: 'var(--vn-space-3)', alignItems: 'flex-start' }}>
            <span style={{ color: 'var(--vn-fg-muted)', marginTop: 2 }}>{icon}</span>
            <span style={{ display: 'grid', gap: 'var(--vn-space-1)' }}>
              <strong style={{ fontSize: 'var(--vn-font-size-sm)' }}>{title}</strong>
              <span style={{ fontSize: 'var(--vn-font-size-xs)', color: 'var(--vn-fg-muted)' }}>
                {description}
              </span>
            </span>
          </span>
          <Switch checked={!!field.value} onCheckedChange={field.onChange} aria-label={title} />
        </label>
      )}
    />
  );
}
